"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distPos = exports.dist = void 0;
var dist = function (p, q) { return Math.abs(p - q); };
exports.dist = dist;
var distPos = function (a, b) {
    return Math.sqrt(Math.pow((a.x - b.x), 2) + Math.pow((a.y - b.y), 2));
};
exports.distPos = distPos;
